import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { IDIOMAS, mudarIdioma, type IdiomaCode } from "@/i18n";

export function LanguageToggle() {
  const { t, i18n } = useTranslation();
  const atual = (i18n.language?.startsWith("en") ? "en" : "pt") as IdiomaCode;

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              aria-label={t("language.label")}
            >
              <Languages className="h-4 w-4" />
              <span className="hidden md:inline uppercase">{atual}</span>
            </Button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <TooltipContent className="md:hidden">
          {t("language.label")}
        </TooltipContent>
      </Tooltip>

      <DropdownMenuContent align="end" className="min-w-36">
        {IDIOMAS.map((idioma) => (
          <DropdownMenuCheckboxItem
            key={idioma.code}
            checked={atual === idioma.code}
            onCheckedChange={() => mudarIdioma(idioma.code)}
            className="cursor-pointer"
          >
            {idioma.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
